/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import { INosKeyFactsData } from './nos-key-facts.data';
import { INosKeyFactsProps } from './nos-key-facts.props.autogenerated';

export interface INosKeyFactsViewProps extends INosKeyFactsProps<INosKeyFactsData> {
    keyFacts: INodeProps;
    className: string;
}

/**
 *
 * NosKeyFacts component
 * @extends {React.PureComponent<INosKeyFactsProps<INosKeyFactsData>>}
 */
class NosKeyFacts extends React.PureComponent<INosKeyFactsProps<INosKeyFactsData>> {
    private readonly className = 'nos-key-facts';
    public render(): JSX.Element | null {
        const viewProps = {
            ...this.props,
            keyFacts: this._renderKeyFacts()
        };

        return this.props.renderView(viewProps);
    }

    private _renderKeyFacts = () => {
        const { config } = this.props;

        return (
            <div className={`${this.className}__container`}>
                {config?.keyFacts?.map((el, index) => {
                    return (
                        <div className={`${this.className}__key-fact-item`} key={index}>
                            {el.icon && (
                                <div className={`${this.className}__icon`}>
                                    <i className={`ms-icon-custom ms-icon-custom--${el.icon}`}>
                                        <span className={`${this.className}__icon-text`}>{el.icon}</span>
                                    </i>
                                </div>
                            )}
                            {el.value && <div className={`${this.className}__value`}>{el.value}</div>}
                            {el.key && <div className={`${this.className}__key`}>{el.key}</div>}
                        </div>
                    );
                })}
            </div>
        );
    };
}

export default NosKeyFacts;
